<template>
  <div>
    <SingleAssignmentDetails v-if="isSingle" />
    <BatchAssignmentDetails v-else />
  </div>
  <HistoryModal />
  <ItemHistoryModal />
  <IntegrationsModal />
  <ItemIntegrationsModal />
  <StatusManagementModal />
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { computed, type ComputedRef, defineComponent } from 'vue'
import { CONSOLIDATE } from '@/const/AssignmentTypes'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import HistoryModal from '@/views/Modals/Assignment/Settings/HistoryModal.vue'
import ItemHistoryModal from '@/views/Modals/Assignment/Settings/ItemHistoryModal.vue'
import IntegrationsModal from '@/views/Modals/Assignment/Settings/IntegrationsModal.vue'
import ItemIntegrationsModal from '@/views/Modals/Assignment/Settings/ItemIntegrationsModal.vue'
import StatusManagementModal from '@/views/Modals/Assignment/Settings/StatusManagementModal.vue'
import BatchAssignmentDetails from '@/views/Assignments/Details/Batch.vue'
import SingleAssignmentDetails from '@/views/Assignments/Details/Single.vue'

export default defineComponent({
  name: 'AssignmentDetails',
  components: {
    HistoryModal,
    ItemHistoryModal,
    IntegrationsModal,
    ItemIntegrationsModal,
    StatusManagementModal,
    BatchAssignmentDetails,
    SingleAssignmentDetails,
  },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const assignment: ComputedRef<Assignment> = computed(
      () => assignmentSummaryStore.assignment as Assignment,
    )

    const isSingle = computed(() => assignment.value?.type !== CONSOLIDATE)

    return {
      assignment,
      isSingle,
    }
  },
})
</script>
